import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { DenyRefillRequestT, ResponseT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { refillAction } from '../api/refillAction.js';
import { rxKeys } from './keys.js';

export interface DenyRefillVariables {
  refillId: number;
  data: DenyRefillRequestT;
  pendingParams?: {
    basic?: Parameters<typeof rxKeys.pendingRefills>[0];
    detailed?: Parameters<typeof rxKeys.pendingRefillsDetailed>[0];
  };
}

export function useDenyRefillMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rx', 'refills', 'deny'],
    mutationFn: async ({ refillId, data }: DenyRefillVariables): Promise<ResponseT> => {
      return await refillAction.deny(refillId, data);
    },
    onSuccess: async (_data, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: rxKeys.pendingRefills(variables.pendingParams?.basic),
        }),
        queryClient.invalidateQueries({
          queryKey: rxKeys.pendingRefillsDetailed(variables.pendingParams?.detailed),
        }),
      ]);
    },
  });
}
